export default __webpack_public_path__ + "static/media/clearp02.66621867.png";